"use client"
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import { usePathname } from "next/navigation";
import { FaArrowLeft } from 'react-icons/fa';
export default function Navbar() {
  const [nav, setNav] = useState(false);
  const pathname = usePathname();


  const links = [
    {
      id: 1,
      link: "/login",
      navName: "Back To Login",
    }
  ];

  return (
    <nav className="fixed top-0 z-40 w-full bg-gray-100 shadow-lg">
      <div className="px-3 py-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between px-5">
          <div className="flex items-center justify-start rtl:justify-end">
            <a
              id="logo"
              className="link-underline link-underline-black"
              href="https://arthpay.com/index.php#home"
              target="_self"
              rel="noreferrer"
            >
              <Image
                src="/img/logo.png"
                alt="Vercel Logo"
                className="h-10 w-full"
                width={100}
                height={40}
              />
            </a>
          </div>
          {
            pathname === "/login/reset" && (
              <ul className="hidden md:flex">
                {links.map(({ id, link, navName }) => (
                  <li
                    key={id}
                    className="nav-links px-4 cursor-pointer capitalize font-medium text-gray-800 hover:scale-105 hover:text-black duration-200 link-underline"
                  >
                    <Link id={navName} href={link} className="flex items-center">
                      <FaArrowLeft className="mr-2" />
                      {navName}
                    </Link>
                  </li>
                ))}
              </ul>
            )
          }
        </div>
      </div>
    </nav>
  );
};